import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DelNovaLOGO from "../../images/DelNova_Logo_New.png";

export default function NavbarRedesign() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      setIsFlipped((prev) => !prev);
    }, 6000);
    return () => clearInterval(timer);
  }, [isHovered]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // Helper to handle hash scroll when on the home page, or redirect to home page
  const handleNavClick = (e, link) => {
    if (link.isHome) {
      if (location.pathname === "/") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        closeMenu();
      }
      return;
    }

    if (link.scrollId) {
      if (location.pathname === "/") {
        e.preventDefault();
        const element = document.getElementById(link.scrollId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        closeMenu();
      }
    }
  };

  const navLinks = [
    { name: "Home", to: "/", isHome: true },
    { name: "About", to: "/AboutUs", scrollId: "about" },
    { name: "R&D", to: "/ResearchAndDevlop", scrollId: "capabilities" },
    { name: "Products", to: "/ResearchAndDevlop" },
    { name: "Services", to: "/Pipeline" },
    { name: "Careers", to: "/Careers" },
  ];

  const productSubLinks = [
    { name: "Generics", to: "/GenericsProduct" },
    { name: "Complex Generics", to: "/ComplexGenerics" },
    { name: "Differentiated Formulations", to: "/DifferntiatedProdDev" },
    { name: "Innovative Products", to: "/InnovativeProdDev" },
  ];

  const isHomePage = location.pathname === "/";

  return (
    <div className="fixed top-0 left-0 w-full z-50 transition-all duration-300 flex flex-col">
      {/* Announcement Slot */}
      {isHomePage && (
        <div
          className={`bg-gradient-to-r from-brand-blue-deep via-brand-blue to-brand-teal text-white w-full overflow-hidden transition-all duration-500 ease-in-out ${
            isScrolled ? "h-0 opacity-0 pointer-events-none" : "h-[4.5rem] md:h-16 opacity-100 border-b border-brand-teal/20"
          }`}
        >
          <div className="max-w-7xl mx-auto h-full px-6 md:px-12 flex items-center justify-center">
            <div
              className="w-full h-full relative"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* Event Navigation Dots */}
              <div className="hidden md:flex absolute -bottom-1 left-1/2 -translate-x-1/2 space-x-1.5 z-20">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsFlipped(false);
                  }}
                  className={`h-1 rounded-full transition-all duration-300 ${!isFlipped ? "bg-yellow-300 w-4" : "bg-white/40 hover:bg-white/80 w-1.5"}`}
                  title="CPHI Milan"
                  aria-label="View CPHI Milan Event"
                />
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsFlipped(true);
                  }}
                  className={`h-1 rounded-full transition-all duration-300 ${isFlipped ? "bg-yellow-300 w-4" : "bg-white/40 hover:bg-white/80 w-1.5"}`}
                  title="IPHEX New Delhi"
                  aria-label="View IPHEX New Delhi Event"
                />
              </div>

              {/* Front Face - CPHI Milan */}
              <div
                className={`absolute inset-0 w-full h-full flex items-center justify-between text-xs md:text-sm font-medium transition-all duration-1000 ease-in-out ${
                  isFlipped
                    ? "opacity-0 pointer-events-none -translate-y-2"
                    : "opacity-100 translate-y-0"
                }`}
              >
                <div className="flex flex-col md:flex-row md:items-center md:space-x-4 text-left min-w-0 pr-2">
                  {/* Headline */}
                  <div className="flex items-center space-x-2">
                    {/* Globe Icon */}
                    <svg className="w-4 h-4 text-brand-teal-light animate-pulse flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                      <path strokeWidth="2" d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                    </svg>
                    <span className="font-bold tracking-wide text-xs md:text-sm text-white">
                      <span className="hidden sm:inline">Meet DelNova Healthcare for Licensing Opportunities at <span className="text-yellow-300 font-extrabold">CPHI Milan</span></span>
                      <span className="sm:hidden">Meet DelNova for Licensing at <span className="text-yellow-300 font-extrabold">CPHI Milan</span></span>
                    </span>
                  </div>
                  {/* Dates & Tagline */}
                  <div className="flex items-center space-x-2 mt-0.5 md:mt-0 border-t md:border-t-0 md:border-l border-white/20 pt-0.5 md:pt-0 md:pl-4">
                    {/* Calendar Icon */}
                    <svg className="w-3.5 h-3.5 text-brand-teal-light flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    <span className="text-[10px] md:text-xs text-slate-200 font-normal">
                      <span className="font-semibold text-white">06 Oct – 08 Oct 2026</span> <span className="hidden lg:inline text-slate-300">| Fiera Milano, Italy</span>
                    </span>
                  </div>
                </div>
                <a
                  href="https://www.cphi.com/europe/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-shrink-0 inline-flex items-center bg-white/10 hover:bg-white/20 border border-white/20 rounded-full px-3 py-1 text-xs transition-colors duration-200 shadow-sm ml-2 md:ml-4"
                >
                  <span className="hidden sm:inline">Event Info</span>
                  <span className="sm:hidden">Info</span>
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              
              {/* Back Face - IPHEX New Delhi */}
              <div
                className={`absolute inset-0 w-full h-full flex items-center justify-between text-xs md:text-sm font-medium transition-all duration-1000 ease-in-out ${
                  isFlipped
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 pointer-events-none translate-y-2"
                }`}
              >
                <div className="flex flex-col md:flex-row md:items-center md:space-x-4 text-left min-w-0 pr-2">
                  {/* Headline */}
                  <div className="flex items-center space-x-2">
                    {/* DelNova Small Logo + Name badge */}
                    <div className="hidden sm:flex items-center space-x-2 bg-white/10 rounded px-2 py-0.5 border border-white/10 flex-shrink-0">
                      <img src={DelNovaLOGO} alt="DelNova" className="h-5 w-auto object-contain brightness-0 invert" />
                      <span className="text-[10px] md:text-xs font-bold tracking-wider text-white">DelNova</span>
                    </div>
                    {/* Handshake Icon */}
                    <svg className="sm:hidden w-4 h-4 text-brand-teal-light flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span className="font-bold tracking-wide text-xs md:text-sm text-white">
                      <span className="hidden sm:inline">Meet Team DelNova at <span className="text-yellow-300 font-extrabold">IPHEX, New Delhi</span></span>
                      <span className="sm:hidden">Meet Team DelNova at <span className="text-yellow-300 font-extrabold">IPHEX New Delhi</span></span>
                    </span>
                  </div>
                  
                  {/* Dates & Tagline */}
                  <div className="flex items-center space-x-2 mt-0.5 md:mt-0 border-t md:border-t-0 md:border-l border-white/20 pt-0.5 md:pt-0 md:pl-4">
                    {/* Calendar Icon */}
                    <svg className="w-3.5 h-3.5 text-brand-teal-light flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    <span className="text-[10px] md:text-xs text-slate-200 font-normal">
                      <span className="font-semibold text-white">07 Sep – 09 Sep 2026</span> <span className="hidden lg:inline text-slate-300">| Pragati Maidan, New Delhi</span>
                    </span>
                  </div>
                </div>
                <a
                  href="https://iphex-india.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-shrink-0 inline-flex items-center bg-white/10 hover:bg-white/20 border border-white/20 rounded-full px-3 py-1 text-xs transition-colors duration-200 shadow-sm ml-2 md:ml-4"
                >
                  <span className="hidden sm:inline">Event Info</span>
                  <span className="sm:hidden">Info</span>
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Navbar */}
      <nav
        className={`w-full transition-all duration-300 ${
          isScrolled
            ? "bg-white py-2 shadow-md border-b border-slate-100"
            : "bg-white py-3 shadow-sm border-b border-slate-100"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
          {/* Logo */}
          <Link
            to="/"
            onClick={(e) => {
              if (location.pathname === "/") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }}
            className="flex items-center transition-transform duration-300 hover:scale-[1.02]"
          >
            <img src={DelNovaLOGO} alt="DelNova Healthcare" className="h-16 md:h-20 w-auto object-contain" />
          </Link>

          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => {
              if (link.name === "Products") {
                return (
                  <div key={link.name} className="relative group py-2">
                    <Link
                      to={link.to}
                      onClick={(e) => handleNavClick(e, link)}
                      className="flex items-center space-x-1 text-slate-600 hover:text-brand-blue font-medium text-[15px] transition-colors duration-200"
                    >
                      <span>{link.name}</span>
                      <svg className="w-3.5 h-3.5 mt-0.5 text-slate-500 group-hover:text-brand-blue transition-transform duration-200 transform group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </Link>
                    {/* Dropdown Menu */}
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 rounded-2xl bg-white border border-slate-100 shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 z-50 overflow-hidden">
                      <div className="p-2 bg-white flex flex-col">
                        {productSubLinks.map((sub) => (
                          <Link
                            key={sub.name}
                            to={sub.to}
                            className="flex items-center px-4 py-3 text-sm text-slate-600 hover:text-brand-teal font-medium hover:bg-slate-50/80 rounded-xl transition-all duration-200"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }
              return (
                <Link
                  key={link.name}
                  to={link.to}
                  onClick={(e) => handleNavClick(e, link)}
                  className="text-slate-600 hover:text-brand-blue font-medium text-[15px] transition-colors duration-200 relative group"
                >
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-brand-teal transition-all duration-300 group-hover:w-full"></span>
                </Link>
              );
            })}
          </div>

          {/* CTA Partner Button */}
          <div className="hidden lg:block">
            <Link
              to="/ContactUs"
              className="inline-flex items-center justify-center px-6 py-2.5 rounded-full text-white font-medium text-sm bg-gradient-to-r from-brand-teal to-brand-teal-dark hover:from-brand-teal-light hover:to-brand-teal shadow-md shadow-brand-teal/10 hover:shadow-lg hover:shadow-brand-teal/20 transition-all duration-300 transform hover:-translate-y-0.5"
            >
              Partner with Us
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={toggleMenu}
            className="lg:hidden text-slate-600 hover:text-brand-blue p-2 focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Drawer Overlay */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-slate-900/30 backdrop-blur-sm z-40 lg:hidden"
            onClick={closeMenu}
          />
        )}

        {/* Mobile Drawer Menu */}
        <div
          className={`fixed top-0 right-0 w-[280px] h-full bg-white z-50 shadow-2xl p-6 flex flex-col justify-between transform transition-transform duration-300 lg:hidden ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="space-y-6">
            <div className="flex justify-between items-center border-b pb-4">
              <span className="font-bold text-lg text-brand-blue">Menu</span>
              <button
                onClick={closeMenu}
                className="text-slate-400 hover:text-slate-600"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => {
                if (link.name === "Products") {
                  return (
                    <div key={link.name} className="flex flex-col">
                      <button
                        onClick={() => setIsMobileProductsOpen(!isMobileProductsOpen)}
                        className="flex justify-between items-center text-slate-600 hover:text-brand-blue font-medium py-2 text-base transition-colors focus:outline-none"
                      >
                        <span>{link.name}</span>
                        <svg className={`w-4 h-4 text-slate-500 transition-transform duration-300 ${isMobileProductsOpen ? "transform rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </button>
                      <div className={`overflow-hidden transition-all duration-300 pl-4 flex flex-col space-y-3 ${isMobileProductsOpen ? "max-h-60 mt-2 mb-4" : "max-h-0"}`}>
                        {productSubLinks.map((sub) => (
                          <Link
                            key={sub.name}
                            to={sub.to}
                            onClick={closeMenu}
                            className="text-slate-500 hover:text-brand-teal font-medium py-1.5 text-sm transition-colors"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  );
                }
                return (
                  <Link
                    key={link.name}
                    to={link.to}
                    onClick={(e) => {
                      handleNavClick(e, link);
                      closeMenu();
                    }}
                    className="text-slate-600 hover:text-brand-blue font-medium py-2 text-base transition-colors"
                  >
                    {link.name}
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="pt-6 border-t">
            <Link
              to="/ContactUs"
              onClick={closeMenu}
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-full text-white font-medium bg-gradient-to-r from-brand-teal to-brand-teal-dark shadow-md transition-all"
            >
              Partner with Us
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}
